import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#e58929",
      contrastText: "white",
    },
    secondary: {
      main: "#999",
    },
    black: {
      main: "#1a1b1f",
    },
    error: {
      main: "#ff5a5f",
    },
    warning: {
      main: "#f39c12",
    },
    info: {
      main: "#3498db",
    },
    success: {
      main: "#2ecc71",
    },
    background: {
      paper: "#404040",
      default: "#404040",
    },
  },
  shape: {
    borderRadius: 16,
  },
});

export default theme;
